import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { httpOptions, api, serviceConstants, formOptions, imageOptions } from '../constants/service.constants';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  userData: Observable<any>;
  userDetails;
  istcurrencyid: string;
  eapcurrencyid: string;
  // grants1currencyid: string; ////CME
  // grants2currencyid: string; ////sponsorship
  // grants3currencyid: string; ////charitable

  grantsCMEcurrencyid: string; ////CME
  grantssponsorshipcurrencyid: string; ////sponsorship
  grantscharitablecurrencyid: string; ////charitable

  token: string;

  loggedInStatus = JSON.parse(localStorage.getItem('loggedIn') || 'false');

  constructor(private http: HttpClient, public router: Router,) {

  }

  clearUserData() {
    this.userDetails = null;;
    this.istcurrencyid = undefined;
    this.eapcurrencyid = undefined;
    this.grantsCMEcurrencyid = undefined;
    this.grantssponsorshipcurrencyid = undefined;
    this.grantscharitablecurrencyid = undefined;
    this.token = undefined;
  }

  getUserData(_id): Observable<any> {
    //if (this.userDetails)
    return this.userDetails;
    //this.userData = this.http.get(api +'/users/'+_id, httpOptions).map(res=> res).shareReplay();
    //return this.userData;
  }

  fetchTimeZones():Observable<any> 
  {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/fetchtimezones', httpOptions);
  }
  timeZoneAutoSave(TimeZone:any):Observable<any>{
   // let requesturl = encodeURIComponent(serviceConstants.apiURL + 'api/appuser/timezoneautosave/?TimeZone=' + TimeZone);
      return this.http.post(serviceConstants.apiURL + 'api/appuser/timezoneautosave/' + TimeZone,  TimeZone , httpOptions);
  }

  GetWindowsTimeZoneFromIANA(TimeZone:any):Observable<any>{
    return this.http.post(serviceConstants.apiURL + 'api/appuser/GetWindowsTimeZoneFromIANA/' + TimeZone , TimeZone, httpOptions);
  }

  userLogin(request): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/login', request, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }
  MultiBrowserVerification(request): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/MultiBrowserVerification', request, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }
  checkUserType(email): Observable<any> {
    return this.http.post(serviceConstants.apiURL + 'api/appuser/checkusertype', email, httpOptions);
    //return this.http.post(api + '/login', request, httpOptions);
  }

  getSSOConfig(orgid: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getssoconfig/' + orgid, imageOptions);
  }

  checkSession(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/checksession', imageOptions);
  }

  getLogo(code: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/downloadifle/' + code, imageOptions);
  }

  getInstruction(): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/common/getinstruction', httpOptions);
  }

  GetUsersRoles(id): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/getur/' + id, httpOptions);
  }

  setLogoImage(image) {
    localStorage.setItem("logoimage", image);
  }

  getLogoImage() {
    return localStorage.getItem("logoimage");
  }

  userLogout(LogOutReason: string, Browser: string, Version: string, userId?: string): Observable<any> {
    return this.http.get(serviceConstants.apiURL + 'api/appuser/logout/' + LogOutReason + '/' + Browser + '/' + Version + '/' + userId, httpOptions);
  }

  setLoggedIn(value: boolean) {
    this.loggedInStatus = value;
    localStorage.setItem('loggedIn', 'true');
  }

  get isLoggedIn() {
    return JSON.parse(localStorage.getItem('loggedIn') || this.loggedInStatus.toString())
  }

  setUserDetails(_userDetails) {
    this.userDetails = _userDetails;
    localStorage.setItem('userDetails', JSON.stringify(_userDetails));
  }



  //IST--SET,GET-ID,SYMBOL,CODE

  setISTCurrency(currencyid) {
    this.istcurrencyid = currencyid;
    localStorage.setItem('ISTCURRENCYID', currencyid);
  }

  getISTCurrencyID() {
    if (this.istcurrencyid === null || this.istcurrencyid === undefined) {
      this.istcurrencyid = localStorage.getItem("ISTCURRENCYID");
    }
    return this.istcurrencyid;
  }
  setISTCurrencysymbol(currencysumbol) {
    localStorage.setItem('IST_CURRENCY_SYMBOL', currencysumbol);
  }

  getISTCurrencySymbol() {
    return this.userDetails.IST_CURRENCY_SYMBOL;
  }

  setISTCurrencycode(currencycode) {
    localStorage.setItem('IST_CURRENCY_CODE', currencycode);
  }

  getISTCurrencyCode() {
    return this.userDetails.IST_CURRENCY_CODE;
  }

  // getISTCurrency() {
  //   if (this.istcurrencyid === null || this.istcurrencyid === undefined) {
  //     this.istcurrencyid = localStorage.getItem("ISTCURRENCYID");
  //   }
  //   return this.istcurrencyid;
  // }

  
  //EAP--SET,GET-ID,SYMBOL,CODE

  setEAPCurrency(currencyid) {
    this.eapcurrencyid = currencyid;
    localStorage.setItem('EAPCURRENCYID', currencyid);
  }

  getEAPCurrencyID() {
    if (this.eapcurrencyid === null || this.eapcurrencyid === undefined) {
      this.eapcurrencyid = localStorage.getItem("EAPCURRENCYID");
    }
    return this.eapcurrencyid;
  }

  setEAPCurrencysymbol(currencysymbol) {
    localStorage.setItem('EAP_CURRENCY_SYMBOL', currencysymbol);
  }

  getEAPCurrencySymbol() {
    return this.userDetails.EAP_CURRENCY_SYMBOL;
  }
  
  setEAPCurrencycode(currencycode) {
    localStorage.setItem('EAP_CURRENCY_CODE', currencycode);
  }

  getEAPCurrencyCode() {
    return this.userDetails.EAP_CURRENCY_CODE;
  }

  // getEAPCurrency() {
  //   if (this.eapcurrencyid === null || this.eapcurrencyid === undefined) {
  //     this.eapcurrencyid = localStorage.getItem("EAPCURRENCYID");
  //   }
  //   return this.eapcurrencyid;
  // }


  //CME--1--SET,GET-ID,SYMBOL,CODE
  
  setGrantsCMECurrency(currencyid) {
    this.grantsCMEcurrencyid = currencyid;
    localStorage.setItem('GRANTS_CME_CURRENCY_ID', currencyid);
  }

  getCMECurrencyID() {
    if (this.grantsCMEcurrencyid === null || this.grantsCMEcurrencyid === undefined) {
      this.grantsCMEcurrencyid = localStorage.getItem("GRANTS_CME_CURRENCY_ID");
    }
    return this.grantsCMEcurrencyid;
  }

  setGrantsCMECurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_CME_CURRENCY_SYMBOL', currencysymbol);
  }
 
  setGrantsCMECurrencycode(currencycode) {
    localStorage.setItem('GRANTS_CME_CURRENCY_CODE', currencycode);
  }

  getGrantCMECurrencyCode() {
    return this.userDetails.GRANTS_CME_CURRENCY_CODE;
  }

 



 //sponsorship--2--SET,GET-ID,SYMBOL,CODE
 
  setGrantssponsorshipCurrency(currencyid) {
    this.grantssponsorshipcurrencyid = currencyid;
    localStorage.setItem('GRANTS_SPONSOR_CURRENCY_ID', currencyid);
  }

  getSponsorCurrencyId() {
    if (this.grantssponsorshipcurrencyid === null || this.grantssponsorshipcurrencyid === undefined) {
      this.grantssponsorshipcurrencyid = localStorage.getItem("GRANTS_SPONSOR_CURRENCY_ID");
    }
    return this.grantssponsorshipcurrencyid;
  }

  setGrantssponsorshipCurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_SPONSOR_CURRENCY_SYMBOL', currencysymbol);
  }

  

  setGrantssponsorshipCurrencycode(currencycode) {
    localStorage.setItem('GRANTS_SPONSOR_CURRENCY_CODE', currencycode);
  }

  getGrantSponsorCurrencyCode() {
    return this.userDetails.GRANTS_SPONSOR_CURRENCY_CODE;
  }

  getGrantSponsorCurrencySymbol(appID:any="0"):any {
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/sponsor/'+appID, httpOptions)
  }

  getGrantCharitableCurrencySymbol(appID:any="0"):any {
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/charity/'+appID, httpOptions)
  }
 getGrantCMECurrencySymbol(appID:any="0"){
    return  this.http.get(serviceConstants.apiURL + 'api/common/getCurrencySymbol/cme/'+appID, httpOptions)
  }


 // return this.http.post((serviceConstants.apiURL + url), formData, this.getHeaders())

  // getGrants2Currency() {
  //   if (this.grantssponsorshipcurrencyid === null || this.grantssponsorshipcurrencyid === undefined) {
  //     this.grantssponsorshipcurrencyid = localStorage.getItem("GRANTS2CURRENCYID");
  //   }
  //   return this.grantssponsorshipcurrencyid;
  // }


//charitable--3--SET,GET-ID,SYMBOL,CODE

  setGrantscharitableCurrency(currencyid) {
     this.grantssponsorshipcurrencyid = currencyid;
     localStorage.setItem('GRANTS_CHARITABLE_CURRENCY_ID', currencyid);
   }
 
  getCharitableCurrencyID() {
    if (this.grantssponsorshipcurrencyid === null || this.grantssponsorshipcurrencyid === undefined) {
      this.grantssponsorshipcurrencyid = localStorage.getItem("GRANTS_CHARITABLE_CURRENCY_ID");
    }
    return this.grantssponsorshipcurrencyid;
  }

  setGrantscharitableCurrencysymbol(currencysymbol) {
    localStorage.setItem('GRANTS_CHARITABLE_CURRENCY_SYMBOL', currencysymbol);
  }

  

  setGrantscharitableCurrencycode(currencycode) {
    localStorage.setItem('GRANTS_CHARITABLE_CURRENCY_CODE', currencycode);
  }
  
  getGrantCharitableCurrencyCode() {
    return this.userDetails.GRANTS_CHARITABLE_CURRENCY_CODE;
  }



  // getGrants3Currency() {
  //   if (this.grantscharitablecurrencyid === null || this.grantscharitablecurrencyid === undefined) {
  //     this.grantscharitablecurrencyid = localStorage.getItem("GRANTS3CURRENCYID");
  //   }
  //   return this.grantscharitablecurrencyid;
  // }

  // setGrants1Currency(currencyid) {
  //   this.grants1currencyid = currencyid;
  //   localStorage.setItem('GRANTS1CURRENCYID', currencyid);
  // }

  // getGrants1Currency() {
  //   if (this.grants1currencyid === null || this.grants1currencyid === undefined) {
  //     this.grants1currencyid = localStorage.getItem("GRANTS1CURRENCYID");
  //   }
  //   return this.grants1currencyid;
  // }

  // setGrants2Currency(currencyid) {
  //   this.grants2currencyid = currencyid;
  //   localStorage.setItem('GRANTS2CURRENCYID', currencyid);
  // }
 
  // setGrants3Currency(currencyid) {
  //   this.grants3currencyid = currencyid;
  //   localStorage.setItem('GRANTS3CURRENCYID', currencyid);
  // }


  setLoggedUserTimeFormat(LoggedUserTimeZone) {
    localStorage.setItem('LoggedUserTimeFormat', LoggedUserTimeZone);
  }
  setLoggedUserDateFormat(LoggedUserTimeZone) {
    localStorage.setItem('LoggedUserDateFormat', LoggedUserTimeZone);
  }
  setLoggedUserTimeZone(LoggedUserTimeZone) {
    localStorage.setItem('LoggedUserTimeZone', LoggedUserTimeZone);
  }
  setLoggedUserOrgTimeZone(LoggedUserOrgTimeZone) {
    localStorage.setItem('LoggedUserOrgTimeZone', LoggedUserOrgTimeZone);
  }
  getLoggedUserTimeFormat() {
    localStorage.getItem('LoggedUserTimeFormat');
  }
  getLoggedUserDateFormat() {
    localStorage.getItem('LoggedUserDateFormat');
  }
  getLoggedUserTimeZone() {
    localStorage.getItem('LoggedUserTimeZone');
  }

  getLoggedUserOrgTimeZone():any {
   return localStorage.getItem('LoggedUserOrgTimeZone');
  }

  setToken(token: string) {
    this.token = token;
    localStorage.setItem('AUTHTOKEN', token);
  }

  getToken() {
    if (this.token === null || this.token === undefined) {
      this.token = localStorage.getItem("AUTHTOKEN");
    }
    return this.token;
  }

  

  

  getOrgCode(): string {
    return localStorage.getItem('orgCode')
  }

  setOrgCode(code: string) {
    localStorage.setItem('orgCode', code);
  }

      getUserDetais() {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    }

    return this.userDetails;
  }

  getUserType(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    }

    return this.userDetails.USER_TYPE;
  }

  getUserName(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    }
    let username = "";
    if (this.userDetails.FIRST_NAME !== null)
      username = this.userDetails.FIRST_NAME;
    if (this.userDetails.MIDDLE_NAME !== null)
      username = username + this.userDetails.MIDDLE_NAME;
    if (this.userDetails.LAST_NAME !== null)
      username = username + this.userDetails.LAST_NAME;
    return username;
  }

  getOrganizationId(): string {
    if (this.userDetails === null || this.userDetails === undefined) {
      this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    }

    return this.userDetails.ORGANIZATION_ID;
  }

  logout(LogOutReason: string, Browser: string, Version: string) {
    let orgCode = this.getOrgCode();
    let user = this.getUserDetais();
    //localStorage.clear();

    this.userLogout(LogOutReason, Browser, Version, user.ID).subscribe(result => {
      if (result.Status == 0) {
        localStorage.clear();
        if (orgCode !== null && orgCode !== "undefined" && orgCode !== '')
        {
          //this.router.navigateByUrl(orgCode + '/login');
          window.location.replace(orgCode + '/login');
        }
        else{
          //this.router.navigateByUrl('/login');
          window.location.replace('/login');
        }
      }
    })
  }

  logoutUserInOtherBrowser = (Id: string, browser: string) => {
    return this.http.get(serviceConstants.apiURL + "api/appuser/LogoutUserInOtherBrowser/" + Id + '/' + browser);
  }

  detectBrowserName() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\bEdg\/(\d+)/)
      if (tem != null) { return { name: 'Edge(Chromium)', version: tem[1] }; }
      tem = ua.match(/\bOPR\/(\d+)/)
      if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
      name: M[0],
      version: M[1]
    };
  }

}

